import React from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Typography,
} from "@material-ui/core";
import { IEstoqueMedicamentoPagedResponse } from "models/response/estoque-medicamento-paged-response";
import { PaginationResponse } from "models/pagination-response";

type EstoquesMedicamentoTableProps = {
    currentItems: PaginationResponse<IEstoqueMedicamentoPagedResponse>;
};

export const EstoquesMedicamentoTable: React.FC<EstoquesMedicamentoTableProps> = ({ currentItems }) => {
    if (!currentItems?.hasItems()) {
        return <Typography variant="body1">Nenhum registro de estoque encontrado.</Typography>;
    }

    return (
        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Medicamento</TableCell>
                        <TableCell>Farmácia/Unidade</TableCell>
                        <TableCell align="right">Quantidade em Estoque</TableCell>
                        <TableCell>Última Atualização</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {currentItems.items.map((item) => (
                        <TableRow key={item.id}>
                            <TableCell>{item.nomeMedicamento}</TableCell>
                            <TableCell>{item.orgaoName || 'Não especificado'}</TableCell>
                            <TableCell align="right">{item.quantidadeEstoque}</TableCell>
                            <TableCell>{new Date(item.dtaAtualizacao).toLocaleDateString('pt-BR')}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};
